function Writeup() {

    return (<div>
        This puzzle is based off an exploit I used in a competition I took part in. We aren't able to share the puzzles so I created my own, exploiting the same vulnerability.
    </div>);
}

export default Writeup;